import { clsx } from 'clsx'
import { type FC } from 'react'

import { useProductPageRebrushStyle } from '../../product-page-context/useProductPageRebrushStyle'

type ProductPageVariantQuantityAndUnitPriceProps = {
  className?: string
  formattedUnitPrice?: string | null
  isProductNotAvailable: boolean
  isProductOutOfSale: boolean
  quantity?: string
}
export const ProductPageVariantQuantityAndUnitPrice: FC<
  ProductPageVariantQuantityAndUnitPriceProps
> = ({
  className,
  formattedUnitPrice,
  isProductNotAvailable,
  isProductOutOfSale,
  quantity,
}) => {
  const isRebrushStyle = useProductPageRebrushStyle()

  return (
    <div
      className={clsx(
        'flex flex-1 basis-2/4 flex-row items-center desktop:basis-3/12',
        className,
      )}
    >
      <div>
        <div
          className={clsx(
            'whitespace-nowrap font-bold',
            isProductNotAvailable
              ? 'text-dark-primary-strong'
              : 'text-dark-primary-max',
            isRebrushStyle && 'text-l font-medium',
            !isRebrushStyle && 'text-m font-bold mobile-md:text-xl',
          )}
          data-qa-id="product-attribute-package_size"
        >
          {quantity}
        </div>
        {formattedUnitPrice && !isProductOutOfSale ? (
          <div className="text-xs text-dark-primary-strong">
            {formattedUnitPrice}
          </div>
        ) : null}
      </div>
    </div>
  )
}
